<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card
          content-color="primary"
          title-color="primary"
          :title="$t('welcome_title')"
        >
          <p>{{ $t("welcome_subtitle") }}</p>
        </vx-card>
      </div>
    </div>
    <div class="vx-col w-full lg:w-1/2 mb-base"></div>
    <div class="vx-row">
      <div class="vx-col lg:w-2/3 w-full mb-base">
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full mb-base">
            <router-link exact :to="linkToAdvise">
              <vx-card
                title="Klopt je termijnbedrag nog?"
                title-color="#fff"
                content-color="#fff"
                card-background="linear-gradient(to right, #56ab2f, #a8e063)"
              >
                Door de roerige gasprijzen kan het zijn dat je termijnbedrag
                aangepast moet worden. Klik hier om te controleren of je
                termijnbedrag nog bij je huidige verbruik past.
              </vx-card>
            </router-link>
          </div>
          <div
            class="vx-col lg:w-1/2 w-full mb-base"
            v-if="customerStatus != null && customerStatus.has_smart_meter"
          >
            <router-link exact to="/usage">
              <vx-card
                title="Verbruik"
                title-color="#fff"
                content-color="#fff"
                card-background="linear-gradient(120deg,  #1080d0, #5ebcff)"
              >
                <feather-icon
                  icon="TrendingUpIcon"
                  class="p-3 inline-flex rounded-full"
                />

                <p>Bekijk hoeveel energie je hebt verbruikt afgelopen tijd.</p>
              </vx-card>
            </router-link>
          </div>
          <div
            class="vx-col lg:w-1/2 w-full mb-base"
            v-if="
              customerStatus != null && customerStatus.has_conventional_meter
            "
          >
            <router-link exact to="/meterreading">
              <vx-card
                title="Meterstanden"
                title-color="#fff"
                content-color="#fff"
                card-background="linear-gradient(120deg,  #1080d0, #5ebcff)"
              >
                <feather-icon
                  icon="TrendingUpIcon"
                  class="p-3 inline-flex rounded-full"
                />

                <p>Bekijk je recente meterstanden.</p>
              </vx-card>
            </router-link>
          </div>
          <div class="vx-col lg:w-1/2 w-full mb-base">
            <router-link exact to="/profile">
              <vx-card
                title="Profiel"
                title-color="#fff"
                content-color="#fff"
                card-background="linear-gradient(120deg,  #1080d0, #5ebcff)"
              >
                <feather-icon
                  icon="UserIcon"
                  class="p-3 inline-flex rounded-full"
                />

                <p>
                  Zijn er gegevens veranderd de afgelopen tijd? Dan kan je dat
                  hier aanpassen.
                </p>
              </vx-card>
            </router-link>
          </div>
          <div class="vx-col lg:w-1/2 w-full mb-base">
            <router-link exact to="/contracts">
              <vx-card
                title="Contracten"
                title-color="#fff"
                content-color="#fff"
                card-background="linear-gradient(120deg,  #1080d0, #5ebcff)"
              >
                <feather-icon
                  icon="FileTextIcon"
                  class="p-3 inline-flex rounded-full"
                />
                <p>
                  Bekijk hier je contracten, hoeveel je betaalt en pas je
                  termijnbedrag hier aan.
                </p>
              </vx-card>
            </router-link>
          </div>
          <div class="vx-col lg:w-1/2 w-full mb-base">
            <router-link exact to="/invoices">
              <vx-card
                title="Betalingen"
                title-color="#fff"
                content-color="#fff"
                card-background="linear-gradient(120deg,  #1080d0, #5ebcff)"
              >
                <feather-icon
                  icon="DollarSignIcon"
                  class="p-3 inline-flex rounded-full"
                />
                <p>
                  Bekijk hier je betalingen en of je nog betalingen open hebt
                  staan.
                </p>
              </vx-card>
            </router-link>
          </div>
          <div class="vx-col lg:w-1/2 w-full  mb-base">
            <router-link exact to="/prices">
              <vx-card
                title="Tarieven"
                title-color="#fff"
                content-color="#fff"
                card-background="linear-gradient(120deg,  #1080d0, #5ebcff)"
              >
                <feather-icon
                  icon="DollarSignIcon"
                  class="p-3 inline-flex rounded-full"
                />
                <p>
                  Bekijk hier de huidige en historische tarieven.
                </p>
              </vx-card>
            </router-link>
          </div>
        </div>
      </div>
      <div class="vx-col lg:w-1/3 w-full mb-base">
        <vx-card
          title="Wijzigingsverzoeken"
          title-color="#fff"
          content-color="#fff"
          card-background="linear-gradient(120deg,  #1080d0, #5ebcff)"
        >
          <mutation-requests-table />
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import mutationRequestsTable from "../layouts/components/MutationRequestsTable.vue";
export default {
  computed: {
    ...mapState(["customerStatus", "mutationRequests", "actions", "contracts"]),
    mutationAvailable() {
      return this.mutationRequests.length > 0;
    },
    linkToAdvise() {
      if (this.contracts != null) {
        let activeContracts = this.contracts.filter(c => c.active);
        return activeContracts.length == 1
          ? `/${activeContracts[0].id}/recurringamount`
          : "/contracts";
      } else {
        return "";
      }
    }
  },
  components: { mutationRequestsTable },
  mounted() {}
};
</script>
<style>
.vs-table--tbody-table tr {
  background: transparent;
}
.vs-con-table .vs-con-tbody {
  background: transparent;
  border: none;
}
.vs-pagination--ul {
  background: transparent;
}
.vs-pagination--li {
  color: #fff;
}
</style>
